export const OPEN = "confirmDialog/OPEN";
export const CLOSE = "confirmDialog/CLOSE";

export const openConfirmDialog = dialogData => ({
  type: OPEN,
  dialogData
});

export const closeConfirmDialog = () => ({
  type: CLOSE
});

const initialState = {
  open: false,
  title: "",
  contentText: "",
  btnLabel: "",
  caution: false,
  handleClick: null
};

const confirmDialog = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      return { open: true, ...action.dialogData };
    case CLOSE:
      return Object.assign({}, state, { open: false });
    default:
      return state;
  }
};

export default confirmDialog;



// WEBPACK FOOTER //
// ./src/redux/modules/confirmDialog.js